<template>
    <div class="flex-align steps flex-spacebetween">
        <span class="steps-left">{{ title }}</span>
        <el-steps :active="active" align-center style="width: 60%">
            <el-step v-for="(item,index) in defaultOptions" :key="index" :title="item"></el-step>
        </el-steps>
        <div class="steps-right flex-align-end">
            <slot name="right" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'BjSteps',
    props: {
        title:{
            type: String,
            default: ''
        },
        defaultOptions: {
            type: Array,
            default() {
                return [];
            },
        },
        active: {
            type:[Number, String],
            default: ''
        }
    },
    data() {
        return {}
    }
}
</script>

<style lang="scss" scoped>
.steps{
    padding: 10px 20px;
    border: 1px solid #ddd;
    border-radius: 10px;
    background: #fff;
    margin-bottom: 10px;
    &-left{
        font-size: 28px;
        width: 20%;
        padding-left: 20px;
    }
    &-right{
        width: 20%;
    }
}
::v-deep .el-step__icon{
    width: 40px;
    height: 40px;
    font-size: 18px;
}
::v-deep .el-step.is-horizontal .el-step__line{
    top: 19px;
}
::v-deep .el-step__title {
    font-size: 12px;
    line-height: 26px;
}
</style>